// these polyfill imports must be the first lines in the file
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
// import 'custom-event-polyfill';
// import 'document-register-element';
import './polyfills';

import React from 'react';
import { Provider } from 'react-redux';

import App from 'app/App';
import createStore from 'store/store';
import './index.scss';
import { ServiceBootstrapper } from 'bootstrapServices';
import { createRoot } from 'react-dom/client';

const serviceBootstrapper = new ServiceBootstrapper();
const services = serviceBootstrapper.services;

const store = createStore({
    services,
});

serviceBootstrapper.applyStore(store);

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
    <React.StrictMode>
        {' '}
        <Provider store={store}>
            <App services={services} />
        </Provider>
    </React.StrictMode>
);
